// services/approvalApi.js
import { hrBaseApi } from "app/services/HrBaseApi";

export const approvalApi = hrBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    approveDocument: builder.mutation({
      query: (payload) => ({
        url: `/Felix/DocumentapprovalCRUD/`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["PendingApprovals"],
    }),
    rejectDocument: builder.mutation({
      query: (payload) => ({
        url: `/Felix/DocumentapprovalCRUD/`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["PendingApprovals"],
    }),

    approvalListPagination: builder.query({
      query: ({ userId, page = 1, pageSize = 10 }) => ({
        url: `/Felix/approvallistPagination/?page=${page}`,
        method: "POST",
        body: {
          id: userId,
          // page: page,
          page_size: pageSize,
        },
      }),
      providesTags: ["PendingApprovals"],
    }),
  }),
});

export const {
  useApproveDocumentMutation,
  useRejectDocumentMutation,
  useApprovalListPaginationQuery, 
} = approvalApi;
